import { ModalsAppState } from '../states/appState'
import { AttachmentProps } from '@/app/models/attachment'
import { layoutActions } from '@Techedge/digitalportal-shared'
import { ResourcesService } from '@/app/services/ResourcesService'
import {
    Chapter,
    FolderType,
    ResourceProps,
    SortingType,
    SurveyProps,
    Visibility,
} from '@/app/models/new-resource'
import { QuickLinkProps } from '@/app/models/new-quick-link'
import { NewActivityCreationActions } from '@redux/actions/activity-creation'

export const Actions = {
    GET_DOCUMENTS_REQUEST: 'GET_DOCUMENTS_REQUEST',
    GET_DOCUMENTS_FAILURE: 'GET_DOCUMENTS_FAILURE',
    GET_DOCUMENTS_SUCCESS: 'GET_DOCUMENTS_SUCCESS',
    GET_FORMS_REQUEST: 'GET_FORMS_REQUEST',
    GET_FORMS_FAILURE: 'GET_FORMS_FAILURE',
    GET_FORMS_SUCCESS: 'GET_FORMS_SUCCESS',
    CREATE_FOLDER_REQUEST: 'CREATE_FOLDER_REQUEST',
    CREATE_FOLDER_FAILURE: 'CREATE_FOLDER_FAILURE',
    CREATE_FOLDER_SUCCESS: 'CREATE_FOLDER_SUCCESS',
    CREATE_DOCUMENT_REQUEST: 'CREATE_DOCUMENT_REQUEST',
    CREATE_DOCUMENT_FAILURE: 'CREATE_DOCUMENT_FAILURE',
    CREATE_DOCUMENT_SUCCESS: 'CREATE_DOCUMENT_SUCCESS',
    COPY_LINK_TO_CLIPBOARD_SUCCESS: 'COPY_LINK_TO_CLIPBOARD_SUCCESS',
    EDIT_FOLDER_REQUEST: 'EDIT_FOLDER_REQUEST',
    EDIT_FOLDER_FAILURE: 'EDIT_FOLDER_FAILURE',
    EDIT_FOLDER_SUCCESS: 'EDIT_FOLDER_SUCCESS',
    EDIT_DOCUMENT_REQUEST: 'EDIT_DOCUMENT_REQUEST',
    EDIT_DOCUMENT_FAILURE: 'EDIT_DOCUMENT_FAILURE',
    EDIT_DOCUMENT_SUCCESS: 'EDIT_DOCUMENT_SUCCESS',
    GET_FOLDER_DETAILS_REQUEST: 'GET_FOLDER_DETAILS_REQUEST',
    GET_FOLDER_DETAILS_FAILURE: 'GET_FOLDER_DETAILS_FAILURE',
    GET_FOLDER_DETAILS_SUCCESS: 'GET_FOLDER_DETAILS_SUCCESS',
    GET_DOCUMENT_DETAILS_REQUEST: 'GET_DOCUMENT_DETAILS_REQUEST',
    GET_DOCUMENT_DETAILS_FAILURE: 'GET_DOCUMENT_DETAILS_FAILURE',
    GET_DOCUMENT_DETAILS_SUCCESS: 'GET_DOCUMENT_DETAILS_SUCCESS',
    PUBLISH_ARTICLE_REQUEST: 'PUBLISH_ARTICLE_REQUEST',
    PUBLISH_ARTICLE_FAILURE: 'PUBLISH_ARTICLE_FAILURE',
    PUBLISH_ARTICLE_SUCCESS: 'PUBLISH_ARTICLE_SUCCESS',
    CREATE_LINK_REQUEST: 'CREATE_LINK_REQUEST',
    CREATE_LINK_FAILURE: 'CREATE_LINK_FAILURE',
    CREATE_LINK_SUCCESS: 'CREATE_LINK_SUCCESS',
    EDIT_LINK_REQUEST: 'EDIT_LINK_REQUEST',
    EDIT_LINK_FAILURE: 'EDIT_LINK_FAILURE',
    EDIT_LINK_SUCCESS: 'EDIT_LINK_SUCCESS',
    GET_LINKS_REQUEST: 'GET_LINKS_REQUEST',
    GET_LINKS_FAILURE: 'GET_LINKS_FAILURE',
    GET_LINKS_SUCCESS: 'GET_LINKS_SUCCESS',
    GET_LINKS_REQUEST_ID: 'GET_LINKS_REQUEST_ID',
    GET_LINKS_FAILURE_ID: 'GET_LINKS_FAILURE_ID',
    GET_LINKS_SUCCESS_ID: 'GET_LINKS_SUCCESS_ID',
    SET_SMART_FILTER: 'SET_SMART_FILTER',
}

// GET DOCUMENTS

export const getDocumentsRequest = () => {
    return { type: Actions.GET_DOCUMENTS_REQUEST }
}

export const getDocumentsError = (error?: any) => {
    return { type: Actions.GET_DOCUMENTS_FAILURE, error }
}

export const getDocumentsSuccess = (documents: ResourceProps[], totalDocuments: number) => {
    return {
        type: Actions.GET_DOCUMENTS_SUCCESS,
        documents,
        totalDocuments,
    }
}

export const getDocuments = (filters: {
    folderId?: string
    folderType?: FolderType
    sortingType?: SortingType
}) => {
    return (dispatch: any, getState: any) => {
        dispatch(getDocumentsRequest())
        let sortedFilters = {
            ...filters,
            sortingType: (getState() as ModalsAppState)?.newResourceReducer?.filters?.sortingType,
        }
        ResourcesService.GetResources(sortedFilters)
            .then((res: any) => {
                if (res && res.data && res.data.data) {
                    dispatch(getDocumentsSuccess(res.data.data, res.data.totalRecords))
                } else {
                    dispatch(getDocumentsError())
                }
            })
            .catch((error: Error) => {
                dispatch(getDocumentsError(error))
            })
    }
}

// GET FORMS

export const getFormsRequest = () => {
    return { type: Actions.GET_FORMS_REQUEST }
}

export const getFormsError = (error?: any) => {
    return { type: Actions.GET_FORMS_FAILURE, error }
}

export const getFormsSuccess = (forms: ResourceProps[], totalForms: number) => {
    return {
        type: Actions.GET_FORMS_SUCCESS,
        forms,
        totalForms,
    }
}

export const getForms = (filters: {
    folderId?: string
    folderType?: FolderType
    sortingType?: SortingType
}) => {
    return (dispatch: any, getState: any) => {
        dispatch(getFormsRequest())
        let sortedFilters = {
            ...filters,
            sortingType: (getState() as ModalsAppState)?.newResourceReducer?.filters?.sortingType,
        }
        ResourcesService.GetResources(sortedFilters)
            .then((res: any) => {
                if (res && res.data && res.data.data) {
                    dispatch(getFormsSuccess(res.data.data, res.data.totalRecords))
                } else {
                    dispatch(getFormsError())
                }
            })
            .catch((error: Error) => {
                dispatch(getFormsError(error))
            })
    }
}

// CREATE FOLDER

export const createFolderRequest = () => {
    return { type: Actions.CREATE_FOLDER_REQUEST }
}

export const createFolderError = (error?: any) => {
    return {
        type: Actions.CREATE_FOLDER_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const createFolderSuccess = (success: string) => {
    return {
        type: Actions.CREATE_FOLDER_SUCCESS,
        toastList: [
            {
                text: success,
            },
        ],
    }
}

export const createFolder = (body: {
    title: string
    folderType: string
    visibility: Visibility[]
    storeList: string[]
    parentFolderId?: string
}) => {
    return (dispatch: any) => {
        dispatch(createFolderRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.CreateFolder(body)
            .then((res: any) => {
                if (res && res?.data && res?.data?.message) {
                    dispatch(createFolderSuccess(res.data.message))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        createFolderError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.error}: ${res.data.output.payload?.message}`
                                : ''
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: Error) => {
                dispatch(createFolderError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// CREATE DOCUMENT

export const createDocumentRequest = () => {
    return { type: Actions.CREATE_DOCUMENT_REQUEST }
}

export const createDocumentError = (error?: any) => {
    return {
        type: Actions.CREATE_DOCUMENT_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const createDocumentSuccess = (success: string) => {
    return {
        type: Actions.CREATE_DOCUMENT_SUCCESS,
        toastList: [
            {
                text: success,
            },
        ],
    }
}

export const createDocument = (
    body: {
        title: string
        resourceType: string
        department: string
        storeList: string[]
        visibility: Visibility[]
        attachments?: AttachmentProps[]
        parentFolderId?: string
        recipients?: string[]
        survey?: SurveyProps
        abstract?: any
        chapters?: Chapter[]
        requiredConfirmReading?: boolean
        enableCommentsAndReactions?: boolean
    },
    publishAfterSave?: boolean
) => {
    return (dispatch: any) => {
        dispatch(createDocumentRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.CreateDocument(body)
            .then((res: any) => {
                if (res && res.data && (res.data.id || res.data.ids) && res.data.message) {
                    if (publishAfterSave) {
                        dispatch(publishArticle(res.data.id))
                    } else {
                        dispatch(createDocumentSuccess(res.data.message))
                        dispatch(
                            layoutActions.setModals({
                                type: null,
                                props: { id: null, loading: false, isEdit: false, isClone: false },
                            })
                        )
                    }
                } else {
                    dispatch(
                        createDocumentError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.error}: ${res.data.output.payload?.message}`
                                : ''
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: Error) => {
                dispatch(createDocumentError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// EDIT FOLDER

export const editFolderRequest = () => {
    return { type: Actions.EDIT_FOLDER_REQUEST }
}

export const editFolderError = (error?: any) => {
    return {
        type: Actions.EDIT_FOLDER_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const editFolderSuccess = (success: string) => {
    return {
        type: Actions.EDIT_FOLDER_SUCCESS,
        toastList: [
            {
                text: success,
            },
        ],
    }
}

export const editFolder = (body: {
    title: string
    visibility: Visibility[]
    storeList: string[]
    folderId: string
    parentFolderId?: string
    force?: boolean
}) => {
    return (dispatch: any) => {
        dispatch(editFolderRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.EditFolder(body)
            .then((res: any) => {
                if (res && res?.data && res?.data?.message) {
                    dispatch(editFolderSuccess(res.data.message))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        editFolderError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.error}: ${res.data.output.payload?.message}`
                                : ''
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: Error) => {
                dispatch(editFolderError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// EDIT DOCUMENT

export const editDocumentRequest = () => {
    return { type: Actions.EDIT_DOCUMENT_REQUEST }
}

export const editDocumentError = (error?: any) => {
    return {
        type: Actions.EDIT_DOCUMENT_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const editDocumentSuccess = (success: string) => {
    return {
        type: Actions.EDIT_DOCUMENT_SUCCESS,
        toastList: [
            {
                text: success,
            },
        ],
    }
}

export const editDocument = (
    _id: string,
    body: {
        title: string
        department?: string
        attachments?: AttachmentProps[]
        parentFolderId?: string
        recipients?: string[]
        survey?: SurveyProps
        abstract?: any
        chapters?: Chapter[]
        resetViewsCount?: boolean
        requiredConfirmReading?: boolean
        enableCommentsAndReactions?: boolean
    },
    publishAfterSave?: boolean
) => {
    return (dispatch: any) => {
        dispatch(editDocumentRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.EditDocument(_id, body)
            .then((res: any) => {
                if (res && res.data && res.data.id && res.data.message) {
                    if (publishAfterSave) {
                        dispatch(publishArticle(res.data.id))
                    } else {
                        dispatch(editDocumentSuccess(res.data.message))
                        dispatch(
                            layoutActions.setModals({
                                type: null,
                                props: { id: null, loading: false, isEdit: false, isClone: false },
                            })
                        )
                    }
                } else {
                    dispatch(
                        editDocumentError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.error}: ${res.data.output.payload?.message}`
                                : ''
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: Error) => {
                dispatch(editDocumentError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// GET FOLDER DETAILS

export const getFolderDetailsRequest = () => {
    return { type: Actions.GET_FOLDER_DETAILS_REQUEST }
}

export const getFolderDetailsError = (error?: any) => {
    return { type: Actions.GET_FOLDER_DETAILS_FAILURE, error }
}

export const getFolderDetailsSuccess = () => {
    return {
        type: Actions.GET_FOLDER_DETAILS_SUCCESS,
    }
}

export const getFolderDetails = (
    filters: {
        folderId?: string
    },
    callback: (data: any[]) => void
) => {
    return (dispatch: any) => {
        dispatch(getFolderDetailsRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.GetResources(filters)
            .then((res: any) => {
                if (res && res.data && res.data.data) {
                    dispatch(getFolderDetailsSuccess())
                    callback(res.data.data)
                } else {
                    dispatch(getFolderDetailsError())
                }
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
            .catch((error: Error) => {
                dispatch(getFolderDetailsError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// GET DOCUMENT DETAILS

export const getDocumentDetailsRequest = () => {
    return { type: Actions.GET_DOCUMENT_DETAILS_REQUEST }
}

export const getDocumentDetailsError = (error?: any) => {
    return { type: Actions.GET_DOCUMENT_DETAILS_FAILURE, error }
}

export const getDocumentDetailsSuccess = () => {
    return {
        type: Actions.GET_DOCUMENT_DETAILS_SUCCESS,
    }
}

export const getDocumentDetails = (documentId: string, callback: (data: ResourceProps) => void) => {
    return (dispatch: any) => {
        dispatch(getDocumentDetailsRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.GetDocument(documentId)
            .then((res: any) => {
                if (res && res.data) {
                    dispatch(getDocumentDetailsSuccess())
                    callback(res.data)
                } else {
                    dispatch(getDocumentDetailsError())
                }
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
            .catch((error: Error) => {
                dispatch(getDocumentDetailsError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// PUBLISH ARTICLE

export const publishArticleRequest = () => {
    return { type: Actions.PUBLISH_ARTICLE_REQUEST }
}

export const publishArticleError = (error?: any) => {
    return {
        type: Actions.PUBLISH_ARTICLE_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const publishArticleSuccess = (success?: string) => {
    return {
        type: Actions.PUBLISH_ARTICLE_SUCCESS,
        toastList: [
            {
                text: success,
            },
        ],
    }
}

export const publishArticle = (documentId: string) => {
    return (dispatch: any) => {
        dispatch(publishArticleRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.PublishArticle(documentId)
            .then((res: any) => {
                if (res && res.data && res.data.message) {
                    dispatch(publishArticleSuccess(res.data.message))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        publishArticleError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.error}: ${res.data.output.payload?.message}`
                                : ''
                        )
                    )
                }
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
            .catch((error: Error) => {
                dispatch(publishArticleError(error))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// CREATE NEW QUICK LINK

export const createLinkRequest = () => {
    return { type: Actions.CREATE_LINK_REQUEST }
}

export const createLinkError = (error?: any) => {
    return {
        type: Actions.CREATE_LINK_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const createLinkSuccess = (success: string) => {
    return {
        type: Actions.CREATE_LINK_SUCCESS,
        toastList: [
            {
                text: success || 'Success',
            },
        ],
    }
}

export const createLink = (
    body: {
        title: string
        url: string
        description: string
        visibility: Visibility[]
        storeList: string[]
    },
    textSuccess: string
) => {
    return (dispatch: any) => {
        dispatch(createLinkRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.CreateQuickLink(body)
            .then((res: any) => {
                if (res && res?.data && !res?.data.output) {
                    dispatch(createLinkSuccess(textSuccess))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        createLinkError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.message}`
                                : 'Error'
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(createLinkError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// EDIT QUICK LINK

export const editLinkRequest = () => {
    return { type: Actions.EDIT_LINK_REQUEST }
}

export const editLinkError = (error?: any) => {
    return {
        type: Actions.EDIT_LINK_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const editLinkSuccess = (success: string) => {
    return {
        type: Actions.EDIT_LINK_SUCCESS,
        toastList: [
            {
                text: success || 'Success',
            },
        ],
    }
}

export const editLink = (
    body: {
        title: string
        url: string
        description: string
        visibility: Visibility[]
        storeList: string[]
    },
    linkId: string,
    successText: string
) => {
    return (dispatch: any) => {
        dispatch(editLinkRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.EditQuickLink(body, linkId)
            .then((res: any) => {
                if (res && res?.data && !res?.data.output) {
                    dispatch(editLinkSuccess(successText))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        editLinkError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.message}`
                                : 'Error'
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(editLinkError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// GET LINKS - ID

export const getLinksRequestID = () => {
    return { type: Actions.GET_LINKS_REQUEST_ID }
}

export const getLinksErrorID = (error?: any) => {
    return {
        type: Actions.GET_LINKS_FAILURE_ID,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const getLinksSuccessID = () => {
    return {
        type: Actions.GET_LINKS_SUCCESS_ID,
    }
}

export const getLinksID = (id: string, callback: (data: any) => void) => {
    return (dispatch: any) => {
        dispatch(getLinksRequestID())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ResourcesService.GetLinksID(id)
            .then((res: any) => {
                if (res && res.data && res.data.quicklinks && res.data.totalQuicklinks) {
                    getLinksSuccessID()
                    callback(res.data)
                } else {
                    dispatch(
                        getLinksErrorID(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.message}`
                                : 'Error'
                        )
                    )
                }
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
            .catch((error: any) => {
                dispatch(getLinksErrorID(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// GET LINKS

export const getLinksRequest = () => {
    return { type: Actions.GET_LINKS_REQUEST }
}

export const getLinksError = (error?: any) => {
    return {
        type: Actions.GET_LINKS_FAILURE,
        toastList: [
            {
                text: error || 'Oops Something went wrong',
            },
        ],
    }
}

export const getLinksSuccess = (links: QuickLinkProps[], totalLinks: number) => {
    return {
        type: Actions.GET_LINKS_SUCCESS,
        links,
        totalLinks,
    }
}

export const getLinks = () => {
    return (dispatch: any) => {
        dispatch(getLinksRequest())

        ResourcesService.GetLinks()
            .then((res: any) => {
                if (res && res.data && res.data.quicklinks && res.data.totalQuicklinks) {
                    dispatch(getLinksSuccess(res.data.quicklinks, res.data.totalQuicklinks))
                } else {
                    dispatch(
                        getLinksError(
                            res?.data?.output?.payload
                                ? `${res.data.output.payload?.message}`
                                : 'Error'
                        )
                    )
                }
            })
            .catch((error: any) => {
                dispatch(getLinksError(error.response?.data?.message || error.message))
            })
    }
}

// SET SMART FILTER

export const setSmartFilterResources = (value: any) => {
    return { type: Actions.SET_SMART_FILTER, value }
}
